// Frontend/geniac/src/api/gdpr.ts
// API client pour les endpoints RGPD (GDPR)

import apiClient from './client';

export interface ExportDataResponse {
  export_info: {
    export_date: string;
    rgpd_article: string;
    format: string;
  };
  personal_data: {
    user: any;
    organization: any;
  };
  subscription_data: {
    current_subscription: any;
    subscription_history: any[];
  };
  projects: any[];
  architectures: any[];
  deployments: any[];
  invoices: any[];
  usage_metrics: any;
  promo_codes_used: any[];
}

export interface RequestDeletionResponse {
  success: boolean;
  message: string;
  confirmation_required: boolean;
  confirmation_email_sent: boolean;
  confirmation_token?: string;
  expires_at?: string;
}

export interface DeleteAccountResponse {
  success: boolean;
  message: string;
  deleted_at: string;
}

/**
 * Exporter toutes les données de l'utilisateur (Article 20 RGPD)
 * Télécharge un fichier JSON avec toutes les données
 */
export const exportUserData = async (): Promise<Blob> => {
  const response = await apiClient.get('/gdpr/export-data', {
    responseType: 'blob'
  });
  return response.data;
};

/**
 * Demander la suppression du compte (Article 17 RGPD)
 * Envoie un email de confirmation avec un lien
 */
export const requestAccountDeletion = async (): Promise<RequestDeletionResponse> => {
  const response = await apiClient.post('/gdpr/request-deletion');
  return response.data;
};

/**
 * Confirmer la suppression du compte avec le token
 * Cette fonction est appelée depuis l'email de confirmation
 */
export const confirmAccountDeletion = async (token: string): Promise<DeleteAccountResponse> => {
  const response = await apiClient.post('/gdpr/delete-account', { token });
  return response.data;
};

export default {
  exportUserData,
  requestAccountDeletion,
  confirmAccountDeletion
};
